import React from 'react';
import { Card, Grid, Space, Spin } from '@arco-design/web-react';
import {
  IconThunderbolt,
  IconCode,
  IconSwap,
  IconUserGroup,
} from '@arco-design/web-react/icon';
import { useTranslation } from 'react-i18next';

const { Row, Col } = Grid;

const formatTokens = (tokens) => {
  if (tokens >= 1_000_000) return `${(tokens / 1_000_000).toFixed(2)}M`;
  if (tokens >= 1_000) return `${(tokens / 1_000).toFixed(1)}K`;
  return String(tokens);
};

const KpiCard = ({ icon, title, value, color }) => (
  <Card
    style={{ borderLeft: `3px solid ${color}` }}
    bodyStyle={{ padding: '16px 20px' }}
  >
    <Space size="mini" style={{ color: '#86909c', fontSize: 13 }}>
      {icon}
      <span>{title}</span>
    </Space>
    <div style={{ fontSize: 24, fontWeight: 600, marginTop: 6 }}>
      {value}
    </div>
  </Card>
);

const LlmCostKpiCards = ({ summary, loading }) => {
  const { t } = useTranslation('finance');

  if (loading) {
    return (
      <div style={{ minHeight: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin size={30} />
      </div>
    );
  }

  if (!summary) return null;

  const totalCost = Number(summary.total_cost_usd || 0);
  const totalTokens = (summary.total_input_tokens || 0) + (summary.total_output_tokens || 0);
  const avgCost = Number(summary.avg_cost_per_call || 0);
  const totalCalls = Number(summary.total_calls || 0);

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} md={6}>
        <KpiCard
          icon={<IconThunderbolt style={{ color: '#00b42a' }} />}
          title={t('costs.kpis.totalCost')}
          value={`$${totalCost.toFixed(4)}`}
          color="#00b42a"
        />
      </Col>
      <Col xs={24} sm={12} md={6}>
        <KpiCard
          icon={<IconCode style={{ color: '#165DFF' }} />}
          title={t('costs.kpis.tokensConsumed')}
          value={formatTokens(totalTokens)}
          color="#165DFF"
        />
      </Col>
      <Col xs={24} sm={12} md={6}>
        <KpiCard
          icon={<IconSwap style={{ color: '#722ed1' }} />}
          title={t('costs.kpis.avgCostPerCall')}
          value={`$${avgCost.toFixed(4)}`}
          color="#722ed1"
        />
      </Col>
      <Col xs={24} sm={12} md={6}>
        <KpiCard
          icon={<IconUserGroup style={{ color: '#ff7d00' }} />}
          title={t('costs.kpis.llmCalls')}
          value={totalCalls.toLocaleString()}
          color="#ff7d00"
        />
      </Col>
    </Row>
  );
};

export default LlmCostKpiCards;
